import React from "react";
import ToolbarHeader from "../../components/ToolbarHeader";
import CustomTable from "../../components/CustomTable";
import { assignedToMe } from "../../components/Vouchers/dummyData";
import { FaCheck } from "react-icons/fa";

const AssignedToMe = () => {
  const activeTick = (
    <div className="flex justify-center items-center w-[3.2rem] h-[3.2rem] rounded-[50%] bg-[var(--successGreen)]">
      <FaCheck color="var(--whiteColor)" />
    </div>
  );
  const inctiveTick = (
    <div className="flex justify-center items-center w-[3.2rem] h-[3.2rem] rounded-[50%] bg-[#DDDDDD]">
      <FaCheck color="var(--whiteColor)" />
    </div>
  );

  const columns = [
    {
      Header: "Module",
      accessor: "module",
    },
    {
      Header: "Edit",
      accessor: "edit",
      Cell: (props) => {
        return (
          <div className="py-3">
            {props?.row?.values?.edit ? activeTick : inctiveTick}
          </div>
        );
      },
    },
    {
      Header: "View",
      accessor: "view",
      Cell: (props) => {
        return (
          <div className="py-3">
            {props?.row?.values?.view ? activeTick : inctiveTick}
          </div>
        );
      },
    },
    {
      Header: "Download",
      accessor: "download",
      Cell: (props) => {
        return (
          <div className="py-3">
            {props?.row?.values?.download ? activeTick : inctiveTick}
          </div>
        );
      },
    },
  ];

  return (
    <div className="dashboard-container">
      <ToolbarHeader
        title="Assigned To Me"
        showBack={false}
        containerClassName="mt-14"
      />
      <div className="bg-[var(--whiteColor)] rounded-[1rem] mt-8 px-4 py-6">
        <CustomTable data={assignedToMe} columns={columns} />
      </div>
    </div>
  );
};

export default AssignedToMe;
